import { Badge, ButtonV2, Card } from '@utilities';
import { NumeratorLogoSparkle } from '@utilities/assets';
import type { ScreenerQuestionBank } from '@api/instant_survey/types';

import styles from './_index.module.scss';

interface LibraryViewProps {
  banks: ScreenerQuestionBank[];
  isError: boolean;
  isLoading: boolean;
  onRetry: () => void;
  onSelectBank: (bank: ScreenerQuestionBank) => void;
  usedScreenerBankIds: ReadonlySet<number>;
}

const LibraryView = ({
  banks,
  isError,
  isLoading,
  onRetry,
  onSelectBank,
  usedScreenerBankIds,
}: LibraryViewProps) => (
  <>
    <p className={styles['library-view-intro']}>
      Use Numerator screener questions to qualify respondents before they continue into your survey.
      These do not count towards your total questions.
    </p>
    {isLoading && <p className={styles['library-view-intro']}>Loading question banks...</p>}
    {isError && (
      <p className={styles['library-view-intro']}>
        Screener question banks could not be loaded.{' '}
        <ButtonV2 onClick={onRetry} size="small" type="button" variant="default">
          Try again.
        </ButtonV2>
      </p>
    )}
    <div className={styles['library-view-grid']}>
      {banks.map((bank) => (
        <button
          aria-label={
            usedScreenerBankIds.has(bank.id)
              ? `${bank.name}, already added to this survey`
              : undefined
          }
          className={styles['library-view-card-button']}
          disabled={usedScreenerBankIds.has(bank.id)}
          key={bank.id}
          onClick={() => onSelectBank(bank)}
          type="button"
        >
          <Card className={styles['library-view-card']} padding="large">
            <NumeratorLogoSparkle className={styles['library-view-card-icon']} />
            <div className={styles['library-view-card-content']}>
              <div className={styles['library-view-card-title-row']}>
                <span className={styles['library-view-card-title']}>{bank.name}</span>
                {usedScreenerBankIds.has(bank.id) && <Badge label="Already added" />}
              </div>
              <span className={styles['library-view-card-description']}>{bank.description}</span>
            </div>
          </Card>
        </button>
      ))}
    </div>
  </>
);

export default LibraryView;
